/* Divided by Design. Calm interactions only. */
(function () {
  "use strict";

  // Reveal on scroll, once each.
  var revealables = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && revealables.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
    revealables.forEach(function (el) { io.observe(el); });
  } else {
    revealables.forEach(function (el) { el.classList.add("is-in"); });
  }

  // Mobile menu.
  var toggle = document.querySelector("[data-menu-toggle]");
  var panel = document.querySelector("[data-menu-panel]");
  if (toggle && panel) {
    toggle.addEventListener("click", function () {
      var open = panel.classList.toggle("is-open");
      panel.hidden = !open;
      toggle.setAttribute("aria-expanded", open ? "true" : "false");
      toggle.textContent = open ? "Close" : "Menu";
    });
  }

  // Keep the hidden precise-variant select in step with option selects.
  var form = document.getElementById("product-form");
  if (form) {
    var optionSelects = form.querySelectorAll(".product__variant");
    var idSelect = form.querySelector(".product__variant-hidden");
    if (idSelect && optionSelects.length) {
      var sync = function () {
        var chosen = [];
        optionSelects.forEach(function (s) { chosen.push(s.value); });
        var target = chosen.join(" / ");
        Array.prototype.forEach.call(idSelect.options, function (opt) {
          if (opt.textContent.trim() === target) { idSelect.value = opt.value; }
        });
      };
      optionSelects.forEach(function (s) { s.addEventListener("change", sync); });
      sync();
    }
  }

  // Collection scroll restoration: Shop -> Product -> Back returns to where you left off.
  // Card images reserve space via CSS aspect-ratio and .reveal animates transform only, so
  // document height is stable at load and a saved offset stays accurate.
  var stream = document.querySelector(".collection__stream");
  if (stream) {
    var scrollKey = "dbd:collection-scroll:" + window.location.pathname + window.location.search;
    var saveScroll = function () {
      try { sessionStorage.setItem(scrollKey, String(window.pageYOffset)); } catch (e) {}
    };

    // Take over from the browser so restoration is deterministic rather than bfcache-dependent.
    if ("scrollRestoration" in history) { history.scrollRestoration = "manual"; }

    window.addEventListener("pagehide", saveScroll);
    document.addEventListener("click", function (e) {
      if (e.target && e.target.closest && e.target.closest(".pcard")) { saveScroll(); }
    });

    var navEntries = performance.getEntriesByType ? performance.getEntriesByType("navigation") : [];
    var cameBack = navEntries.length ? navEntries[0].type === "back_forward" : false;
    var stored = null;
    try { stored = sessionStorage.getItem(scrollKey); } catch (e) {}

    if (cameBack && stored !== null) {
      var y = parseInt(stored, 10);
      if (!isNaN(y)) {
        // Re-apply across layout settling: images decoding and fonts swapping both reflow.
        var restore = function () { window.scrollTo(0, y); };
        restore();
        requestAnimationFrame(restore);
        window.addEventListener("load", restore);
      }
    }
  }

  // Shop filter drawer: close on outside click or Escape (progressive enhancement; works without JS).
  var filterEl = document.querySelector("[data-filter]");
  if (filterEl) {
    document.addEventListener("click", function (e) {
      if (filterEl.open && !filterEl.contains(e.target)) { filterEl.open = false; }
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && filterEl.open) {
        filterEl.open = false;
        var s = filterEl.querySelector("summary");
        if (s) { s.focus(); }
      }
    });
  }
})();

// Bag: quantity changes apply immediately — no Update button (§C.1).
// Progressive enhancement: without JS, the <noscript> Update button submits the same form.
document.addEventListener("DOMContentLoaded", function () {
  var cartForm = document.querySelector(".cart__form");
  if (cartForm) {
    cartForm.addEventListener("change", function (e) {
      if (e.target && e.target.classList.contains("cart__qty")) { cartForm.submit(); }
    });
  }
});

// Subscriber invitation — founding campaign, 2026. Quiet by design:
// appears once per session after 30s or ~45% scroll (whichever first),
// never on the cart page (not rendered there), never again on a browser
// that has subscribed via the card or the footer. Campaign-namespaced keys
// so a future campaign starts with clean state.
(function () {
  "use strict";
  var card = document.querySelector("[data-invite]");
  if (!card) { return; }

  var SUBSCRIBED = "dbd_founding_invite_2026_subscribed";
  var SESSION = "dbd_founding_invite_2026_session";

  var get = function (bag, key) { try { return bag.getItem(key); } catch (e) { return null; } };
  var set = function (bag, key) { try { bag.setItem(key, "1"); } catch (e) {} };

  // Any successful signup returns with ?customer_posted=true — remember it.
  if (window.location.search.indexOf("customer_posted") !== -1) { set(localStorage, SUBSCRIBED); }

  // Mark this browser subscribed on genuine newsletter submissions only (card or
  // footer). The Contact form also posts contact[email]; requiring the hidden
  // newsletter tag keeps contact messages from ever setting subscriber state.
  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (f && f.querySelector && f.querySelector('input[name="contact[tags]"][value="newsletter"]')) {
      set(localStorage, SUBSCRIBED);
      set(sessionStorage, SESSION);
    }
  });

  if (get(localStorage, SUBSCRIBED) || get(sessionStorage, SESSION)) { return; }

  var shown = false;
  var timer = null;

  var onScroll = function () {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (max > 0 && window.pageYOffset / max >= 0.45) { show(); }
  };

  var show = function () {
    if (shown) { return; }
    shown = true;
    window.removeEventListener("scroll", onScroll);
    if (timer) { clearTimeout(timer); }
    set(sessionStorage, SESSION);
    card.hidden = false;
    card.classList.add("is-entering");
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { card.classList.add("is-in"); });
    });
  };

  var dismiss = function () { card.hidden = true; };

  timer = setTimeout(show, 30000);
  window.addEventListener("scroll", onScroll, { passive: true });

  var close = card.querySelector("[data-invite-close]");
  if (close) { close.addEventListener("click", dismiss); }
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && !card.hidden) { dismiss(); }
  });
})();
